// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD7zG-u9OzJK519XoeLvtE0hlIqZp_Hljo",
  authDomain: "rts-client-portal.firebaseapp.com",
  projectId: "rts-client-portal",
  storageBucket: "rts-client-portal.firebasestorage.app",
  messagingSenderId: "853997083218",
  appId: "1:853997083218:web:21214015e4ef52863b5d8b",
  measurementId: "G-FRCV8H5B5E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);